<h2 class="app-payment-methods-title" [kitText]="titleText"></h2>

<div class="app-payment-methods-row">
  <span class="app-payment-methods-label" [kitValueLabel]="paymentMethodModel"></span>
  <span class="app-payment-methods-value" [kitValue]="paymentMethodModel"></span>
</div>
